import { Box, Typography, Card } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import GoogleMaterialIcon from "components/google-icon";

export default function BookingDateSelection({ timezone }) {
    const { control } = useFormContext()

    return (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3 }}>
            <Box sx={{ flex: 1, p: { xs: 3 } }}>
                <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }} > Select Date & Time </Typography>
                <Card>
                    <Controller
                        name="date"
                        control={control}
                        render={({ field }) => (
                            <StaticDatePicker
                                {...field}
                                onChange={(d) => field.onChange(d)}
                                displayStaticWrapperAs="desktop"
                                minDate={new Date()}
                                views={["day"]}
                                slotProps={{
                                    toolbar: { hidden: true },
                                    actionBar: { actions: [] },
                                }}
                            />
                        )}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", px: 2, pb: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary">Time zone</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <GoogleMaterialIcon icon="globe" filled sx={{ color: "text.secondary" }} />
                            <Typography variant="body2" > {timezone} </Typography>
                        </Box>
                    </Box>
                </Card>
            </Box>
        </Box>
    );
}